import { h, render, Component } from 'preact';
import { translate } from 'react-i18next';

import OtherSettingsGrids from '../OtherSettingsGrids.js';


class Other extends Component {

  clickyclickyboomboom = (type) => {
  	switch (type) {
  		case 'transactions':
  			this.setState({ type: 'transactions' });
  			break;
  		case 'rewards':
  			this.setState({ type: 'rewards' });
  			break;
  		case 'affiliates':
  			this.setState({ type: 'affiliates' });
  			break;
  		default:
  			this.setState({ type: 'transactions' });
  	}
  }

  constructor(props) {
  	super(props);
  	this.state = {
  		type: 'transactions',
  		data: null,
			affiliates: false,
			currency: null
  	};
  }
	
  componentDidMount() {
  	fetch('https://api.hirezstudios.com/acct/info', {
  		method: 'POST',
  		headers: {
  			'Content-Type': 'application/json'
  		},
  		body: `{"webToken": "${this.props.webToken}"}`
  	}).then((response) => response.json()).then((response) => {
  		this.setState({ data: response });
			this.setState({ affiliates: this.state.data.isAffiliate });
			this.setState({ currency: this.state.data.contactInfo.currency });
  	});
  }


  render() {
		const { t } = this.props;
  	return (
  		<div className="other-settings">
  			<div className="nav">
  				<div className="rewards-container" onClick={() => this.clickyclickyboomboom('transactions')}>
  					<div className={`transaction rewards ${this.state.type === 'transactions' ? ' active' : ''}`}>
            {t('Recent Transactions')}
  					</div>
  				</div>
  				<div className="rewards-container" onClick={() => this.clickyclickyboomboom('rewards')}>
  					<div className={`recent rewards ${this.state.type === 'rewards' ? ' active' : ''}`}>
              {t('Recent Rewards')}
  					</div>
  				</div>
  				{this.state.affiliates &&
						<div className="rewards-container" onClick={() => this.clickyclickyboomboom('affiliates')}>
							<div className={`affiliates rewards  ${this.state.type === 'affiliates' ? ' active' : ''}`}>
								{t('Affiliate Rewards')}
  					</div>
						</div>
  				}
  			</div>
				<OtherSettingsGrids type={this.state.type} webToken={this.props.webToken} affiliates={this.state.affiliates} currency={this.state.currency} />
  		</div>
  	);
  }
}

export default translate(['common'], { withRef: true })(Other);



// WEBPACK FOOTER //
// ./components/views/OtherSettings.js